var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useRef } from "react";
import { FormattedMessage, FormattedDate, useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Prompt } from "react-router-dom";
import { Pane, PaneFooter, Button, TextField, KeyValue, Row, Col, AccordionSet, Accordion, Badge, Loading, Layout, Icon, Headline, ConfirmationModal, Callout, } from "@folio/stripes/components";
import { useOkapiKy, useStripes } from "@folio/stripes/core";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { createProfileUpdateSchema, } from "../utils/validationUtils";
import { useModal } from "../utils/useModal";
import { buildChangePasswordUrl, } from "../utils/accountConsoleUrl";
import { getErrorInfo, isOptimisticLockConflict, } from "../utils/getErrorCode";
import { getUserErrorMessageId } from "../utils/getErrorMessageId";
import { fetchCurrentUser, updateCurrentUser } from "../api/userService";
import { fetchOrganizationNames } from "../api/organizationService";
import useAuthorityTypes from "../hooks/useAuthorityTypes";
import { authorityTypeLabel, roleScreenAuthorityTypes, } from "../utils/authorityTypes";
import { classifyAssignment, describeAssignment, rowsOfType, } from "../utils/nkRoles";
import { getHeaders } from "../api/apiUtils";
import ActionErrorModal from "../components/ActionErrorModal";
var toFormValues = function (user) {
    var _a;
    return ({
        firstName: user.firstName,
        lastName: user.lastName,
        phone: (_a = user.phone) !== null && _a !== void 0 ? _a : "",
    });
};
var MyProfile = function () {
    var _a, _b, _c, _d, _e;
    var intl = useIntl();
    var ky = useOkapiKy();
    var stripes = useStripes();
    var queryClient = useQueryClient();
    var _f = useModal(), isOpen = _f.isOpen, message = _f.message, openModal = _f.openModal, closeModal = _f.closeModal;
    var _g = React.useState(false), showConflictModal = _g[0], setShowConflictModal = _g[1];
    var _h = React.useState(false), showLeaveForPasswordModal = _h[0], setShowLeaveForPasswordModal = _h[1];
    var calloutRef = React.useRef(null);
    var schema = useMemo(function () { return createProfileUpdateSchema(intl); }, [intl]);
    var _j = useForm({
        resolver: zodResolver(schema),
        defaultValues: { firstName: "", lastName: "", phone: "" },
        mode: "onBlur",
        shouldFocusError: false,
    }), handleSubmit = _j.handleSubmit, control = _j.control, reset = _j.reset, _k = _j.formState, errors = _k.errors, isSubmitting = _k.isSubmitting, isDirty = _k.isDirty;
    var _l = useQuery(["czna-users", "me"], function () { return fetchCurrentUser(ky); }, {
        retry: false,
    }), user = _l.data, isLoading = _l.isLoading, userError = _l.error, refetch = _l.refetch;
    var isNotFound = userError !== null &&
        typeof userError === "object" &&
        "response" in userError &&
        userError.response.status === 404;
    // Only fetch _self to detect admin when profile is not found
    var selfData = useQuery(["folio-self"], function () {
        return ky
            .get("users-keycloak/_self", { headers: getHeaders() })
            .json();
    }, {
        enabled: isNotFound,
        staleTime: 5 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
        retry: 1,
    }).data;
    var isAdmin = ((_a = selfData === null || selfData === void 0 ? void 0 : selfData.user) === null || _a === void 0 ? void 0 : _a.username) === "admin";
    /**
     * CZNA-1611: the roles the user holds per authority type, shown under the global roles —
     * only the held types, in the order and with the names the user detail uses (CZNA-1598).
     * When the type list cannot be loaded the held types still show, by their codes.
     */
    var _m = useAuthorityTypes(), authorityTypes = _m.authorityTypes, authorityTypesLoading = _m.isLoading;
    var typeAssignments = roleScreenAuthorityTypes(intl, authorityTypes, ((_b = user === null || user === void 0 ? void 0 : user.authorityTypeRoles) !== null && _b !== void 0 ? _b : []).map(function (r) { return r.authorityType; }), { unheldRecordTypes: false }).map(function (type) { return ({
        code: type.code,
        label: authorityTypeLabel(intl, type),
        assignment: classifyAssignment(rowsOfType(user === null || user === void 0 ? void 0 : user.authorityTypeRoles, type.code)),
    }); });
    /**
     * Every organization this page names, resolved in one request: the user's own, and the
     * scopes of a non-standard assignment (only that names organizations, and it may name a
     * library the user does not belong to). Read from the COLLECTION endpoint — a plain user
     * holds no `organizations.item.get`, so reading by id would answer 403 to exactly the users
     * this page is for. An organization the collection does not return stays unresolved: a
     * scope then prints as its id.
     */
    var organizationIds = Array.from(new Set(__spreadArray(__spreadArray([], ((user === null || user === void 0 ? void 0 : user.organizationId) ? [user.organizationId] : []), true), typeAssignments.flatMap(function (_a) {
        var assignment = _a.assignment;
        return assignment.kind === "nonStandard"
            ? assignment.rows
                .map(function (r) { return r.organizationId; })
                .filter(function (id) { return !!id; })
            : [];
    }), true))).sort();
    var organizationNames = useQuery(__spreadArray(["czna-organizations", "names"], organizationIds, true), function () { return fetchOrganizationNames(ky, organizationIds); }, { enabled: organizationIds.length > 0 }).data;
    var globalRoleCount = (_d = (_c = user === null || user === void 0 ? void 0 : user.roles) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    useEffect(function () {
        if (user) {
            reset(toFormValues(user));
        }
    }, [user, reset]);
    // Warn on browser close/reload with unsaved changes
    var isDirtyRef = useRef(isDirty);
    isDirtyRef.current = isDirty;
    // Set once the user has already confirmed leaving in our own modal, so the browser
    // does not ask the same question again on the navigation that follows.
    var leaveConfirmedRef = useRef(false);
    useEffect(function () {
        var handler = function (e) {
            if (isDirtyRef.current && !leaveConfirmedRef.current) {
                e.preventDefault();
            }
        };
        window.addEventListener("beforeunload", handler);
        return function () { return window.removeEventListener("beforeunload", handler); };
    }, []);
    var saveMutation = useMutation(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, updateCurrentUser(ky, __assign(__assign({}, values), { version: user === null || user === void 0 ? void 0 : user.version }))];
        });
    }); }, {
        onSuccess: function (updatedUser) {
            var _a;
            queryClient.invalidateQueries(["czna-users", "me"]);
            reset(toFormValues(updatedUser));
            (_a = calloutRef.current) === null || _a === void 0 ? void 0 : _a.sendCallout({
                type: "success",
                message: intl.formatMessage({
                    id: "ui-czna-users.myProfile.save.success",
                }),
            });
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var errorInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(error)];
                    case 1:
                        errorInfo = _a.sent();
                        // CZNA-1603: by the code, not the status — "No authenticated user" is a 409 too.
                        if (isOptimisticLockConflict(errorInfo)) {
                            setShowConflictModal(true);
                        }
                        else {
                            openModal(intl.formatMessage({ id: getUserErrorMessageId(errorInfo) }));
                        }
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleConflictReload = function () {
        setShowConflictModal(false);
        queryClient.invalidateQueries(["czna-users", "me"]);
        refetch();
    };
    var handleCancel = function () {
        if (user) {
            reset(toFormValues(user));
        }
    };
    var onSubmit = function (values) {
        saveMutation.mutate(values);
    };
    // CZNA-1592: the password is changed in the Keycloak Account Console, which leads back
    // to the page the user is on now. Null when stripes has no Keycloak to send them to.
    // stripes-types declares `okapi` and `config` as unknown, hence the assertion.
    var changePasswordUrl = buildChangePasswordUrl({ okapi: stripes.okapi, config: stripes.config }, "".concat(window.location.origin).concat(window.location.pathname));
    var goToChangePassword = function () {
        window.location.assign(changePasswordUrl);
    };
    // Leaving through window.location bypasses the router <Prompt>, so unsaved edits are
    // confirmed here instead.
    var handleChangePassword = function () {
        if (isDirty) {
            setShowLeaveForPasswordModal(true);
        }
        else {
            goToChangePassword();
        }
    };
    var handleConfirmLeaveForPassword = function () {
        setShowLeaveForPasswordModal(false);
        leaveConfirmedRef.current = true;
        goToChangePassword();
    };
    // Rendered both on the profile form and on the "no CZNA profile" screen: the system
    // admin and a Keycloak user without a CZNA profile still have a password in the realm.
    var securitySection = changePasswordUrl && (React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.myProfile.section.security" }) },
        React.createElement(Button, { onClick: handleChangePassword },
            React.createElement(FormattedMessage, { id: "ui-czna-users.myProfile.changePassword" }))));
    if (isLoading) {
        return (React.createElement(Pane, { defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-users.myProfile.title" }) },
            React.createElement(Loading, null)));
    }
    if (isNotFound) {
        return (React.createElement(Pane, { defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-users.myProfile.title" }) },
            React.createElement(Layout, { className: "centered" },
                React.createElement(Layout, { className: "marginTopLarge" },
                    React.createElement(Icon, { icon: "profile", size: "large" }),
                    React.createElement(Headline, { size: "large", margin: "medium" },
                        React.createElement(FormattedMessage, { id: isAdmin
                                ? "ui-czna-users.myProfile.admin.heading"
                                : "ui-czna-users.myProfile.notFound.heading" })),
                    React.createElement("p", null,
                        React.createElement(FormattedMessage, { id: isAdmin
                                ? "ui-czna-users.myProfile.admin.message"
                                : "ui-czna-users.myProfile.notFound.message" })))),
            securitySection && React.createElement(AccordionSet, null, securitySection)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Prompt, { when: isDirty, message: intl.formatMessage({
                id: "ui-czna-users.myProfile.unsavedChanges",
            }) }),
        React.createElement("form", { noValidate: true, onSubmit: handleSubmit(onSubmit) },
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-users.myProfile.title" }), footer: React.createElement(PaneFooter, { renderEnd: React.createElement(React.Fragment, null,
                        React.createElement(Button, { marginBottom0: true, onClick: handleCancel, disabled: !isDirty },
                            React.createElement(FormattedMessage, { id: "ui-czna-users.cancel" })),
                        React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, disabled: !isDirty || isSubmitting },
                            React.createElement(FormattedMessage, { id: "ui-czna-users.save" }))) }) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.myProfile.section.general" }) },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "firstName", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.firstName" }), error: (_b = errors.firstName) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "lastName", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.lastName" }), error: (_b = errors.lastName) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.email" }), value: user === null || user === void 0 ? void 0 : user.email })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "phone", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(TextField, __assign({}, field, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.phone" }), error: (_b = errors.phone) === null || _b === void 0 ? void 0 : _b.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.users.organization" }), value: ((user === null || user === void 0 ? void 0 : user.organizationId) &&
                                        (organizationNames === null || organizationNames === void 0 ? void 0 : organizationNames[user.organizationId])) ||
                                        "-" })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.createdAt" }), value: (user === null || user === void 0 ? void 0 : user.createdAt) ? (React.createElement(FormattedDate, { value: user.createdAt })) : ("-") })))),
                    React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.myProfile.section.roles" }), displayWhenClosed: React.createElement(Badge, null, globalRoleCount + typeAssignments.length) }, (_e = user === null || user === void 0 ? void 0 : user.roles) === null || _e === void 0 ? void 0 :
                        _e.map(function (role) { return (React.createElement("div", { key: role.id },
                            React.createElement(FormattedMessage, { id: "ui-czna-users.role.".concat(role.role) }))); }),
                        authorityTypesLoading && typeAssignments.length > 0 ? (React.createElement(Loading, null)) : (typeAssignments.map(function (_a) {
                            var code = _a.code, label = _a.label, assignment = _a.assignment;
                            return (React.createElement("div", { key: code },
                                React.createElement(FormattedMessage, { id: "ui-czna-users.myProfile.authorityTypeRole", values: {
                                        authorityType: label,
                                        // An organization that cannot be resolved prints as its id —
                                        // never as "celostátně", which would understate the row's reach.
                                        role: describeAssignment(intl, assignment, function (orgId) { return organizationNames === null || organizationNames === void 0 ? void 0 : organizationNames[orgId]; }),
                                    } })));
                        })),
                        globalRoleCount === 0 && typeAssignments.length === 0 && (React.createElement(FormattedMessage, { id: "ui-czna-users.users.noRoles" }))),
                    securitySection))),
        React.createElement(ConfirmationModal, { open: showConflictModal, heading: intl.formatMessage({
                id: "ui-czna-users.error.conflict.heading",
            }), message: intl.formatMessage({ id: "ui-czna-users.error.conflict" }), onConfirm: handleConflictReload, onCancel: function () { return setShowConflictModal(false); }, confirmLabel: intl.formatMessage({
                id: "ui-czna-users.error.conflict.reload",
            }) }),
        React.createElement(ConfirmationModal, { open: showLeaveForPasswordModal, heading: intl.formatMessage({
                id: "ui-czna-users.unsavedChanges.heading",
            }), message: intl.formatMessage({
                id: "ui-czna-users.unsavedChanges.message",
            }), confirmLabel: intl.formatMessage({
                id: "ui-czna-users.unsavedChanges.confirm",
            }), cancelLabel: intl.formatMessage({
                id: "ui-czna-users.unsavedChanges.cancel",
            }), onConfirm: handleConfirmLeaveForPassword, onCancel: function () { return setShowLeaveForPasswordModal(false); } }),
        React.createElement(ActionErrorModal, { open: isOpen, message: message, onClose: closeModal }),
        React.createElement(Callout, { ref: calloutRef })));
};
export default MyProfile;
